import { Prose } from "../Prose";

export function Education() {
  return (
    <Prose className="whitespace-pre-line">
      <span className="italic">
        {"BS in Computer Science and Applied Mathematics,\n"}
      </span>
      <span className="font-bold">Colorado School of Mines</span>
    </Prose>
  );
}
